import React from 'react'
import Link from 'gatsby-link'

const PostTemplate = ({ data }) => (
  <div className="container text-center">
    <h1>{data.strapiPost.title}</h1>
    <p>
      by{' '}
      <Link
        to={`/authors/${data.strapiPost.author && data.strapiPost.author.id}`}
      >
        {(data.strapiPost.author && data.strapiPost.username) ||
          'Not specified'}
      </Link>
    </p>
    <p>{data.strapiPost.body}</p>
    <Link to="/">← Go back to the homepage</Link>
  </div>
)

export default PostTemplate

export const query = graphql`
  query PostTemplate($id: String!) {
    strapiPost(id: { eq: $id }) {
      title
      body
      author {
        id
        username
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/post.js